import { useState } from 'react';

export default function Products() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const products = [
    {
      name: 'Rice: A Grain That Connects Cultures',
      description: 'Rice has been a central part of human diets for centuries, bringing people together through shared meals and traditions. Its ability to absorb flavors makes it suitable for countless dishes, from everyday comfort food to festive feasts. Across the world, rice represents nourishment, hospitality, and cultural identity.',
      image: 'https://static.readdy.ai/image/57610a2a25a44577dbc5593c17f23216/e09f67519682000907ee0ce35d0b2cde.webp'
    },
    {
      name: 'Rice: The Foundation of Global Cuisine',
      description: 'As one of the most widely consumed foods on the planet, rice plays a vital role in global food security. It is affordable, easy to store, and adaptable to different climates, making it essential for both rural and urban communities. Rice continues to support livelihoods while feeding millions every day.',
      image: 'https://static.readdy.ai/image/57610a2a25a44577dbc5593c17f23216/af9e5b14fe35ba12b02cee49d1c10a80.jpeg'
    },
    {
      name: 'Rice: Simple, Nutritious, and Versatile',
      description: 'Rice is valued for its simplicity and nutritional benefits. It provides essential energy, is naturally gluten-free, and pairs well with vegetables, meats, and spices. Whether boiled, steamed, or fried, rice fits effortlessly into healthy and balanced meals.',
      image: 'https://static.readdy.ai/image/57610a2a25a44577dbc5593c17f23216/efea6eaee34a01ec04caa5fc5bf205a0.jpeg'
    },
    {
      name: 'Sona Masoori Rice',
      description: 'Lightweight and aromatic medium-grain rice variety, perfect for everyday meals with excellent cooking properties',
      image: 'https://public.readdy.ai/ai/img_res/23d9bcc41852662bcb902e94221d2d9a.jpg'
    },
    {
      name: 'Parboiled Golden Rice',
      description: 'Partially pre-cooked golden parboiled rice retaining more nutrients, with firm texture and excellent shelf life',
      image: 'https://readdy.ai/api/search-image?query=golden%20parboiled%20rice%20grains%20in%20burlap%20sack%20with%20wooden%20scoop%20on%20rustic%20surface%20warm%20lighting%20clean%20minimal%20background%20showcasing%20nutritious%20export%20quality%20processed%20rice&width=800&height=600&seq=rice5&orientation=landscape'
    }
  ];

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % products.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + products.length) % products.length);
  };

  return (
    <section id="products" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <strong className="text-teal-600">Products</strong>
          </h2>
          <div className="w-24 h-1 bg-teal-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Export-quality rice varieties for worldwide distribution
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto">
          <div className="overflow-hidden rounded-2xl shadow-2xl">
            <div
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
              {products.map((product, index) => (
                <div key={index} className="min-w-full">
                  <div className="bg-white" data-product-shop>
                    <div className="w-full h-96">
                      <img
                        src={product.image}
                        alt={product.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="p-8 text-center">
                      <h3 className="text-3xl font-bold text-gray-900 mb-3">
                        {product.name}
                      </h3>
                      <p className="text-gray-600 text-lg leading-relaxed">
                        {product.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button
            onClick={prevSlide}
            className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-teal-600 hover:text-white transition-all cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>

          <button
            onClick={nextSlide}
            className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-teal-600 hover:text-white transition-all cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>

          <div className="flex justify-center space-x-3 mt-6">
            {products.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                  index === currentIndex ? 'bg-teal-600 w-8' : 'bg-gray-300'
                }`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
